<template>
  <div class="content" style="overflow-x:hidden;">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card>
          <md-card-header data-background-color="green">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h4 class="title">Chat Box</h4>
              <div class="ms-auto">
                <!-- <input type="text" v-model="searchText" class="gridFilter" style="margin:5px 5px 0 0;" placeholder="Search..."> -->

              </div>
            </div>
          </md-card-header>
          <md-card-content>
            <div class="col-md-12" style="overflow-x:auto;">
              <div class="task-table">
                <div v-if="loadingTasks" class="text-center">
                  <p>{{ loadingTasks }}</p>
                </div>
                <div v-else id="app">
                  <div class="chat-box">
                    <div class="messages justify-content-between" style="overflow-y: auto; max-height: 250px;">
                      <div v-for="(message, index) in messages" :key="index">
                        <div v-if="UserID != message.SenderId" class="text-left message">
                          <span class="received text-left">{{ `${message.SenderName}: ${message.Message}`  }}</span>
                        </div>
                        <div v-else class="text-right message">
                          <span class="sent text-right">{{`${message.SenderName}: ${message.Message}` }}</span>
                        </div>
                      </div>
                    </div>
                    <form @submit.prevent="sendMessage">
                      <div class="input-box">
                        <input type="text" v-model="text" placeholder="Type your message..."
                          style="width: calc(100% - 60px);">
                        <button @click="sendMessage" type="button" style="width: 60px;">Send</button>
                        <!-- <div>
                          <ul>
                            <li v-for="(msg, index) in receivedMessages" :key="index">{{ msg }}</li>
                          </ul>
                          <input type="text" v-model="message" @keyup.enter="sendMessage" />
                          <button @click="sendMessage">Send</button>
                        </div> -->
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<!-- Use the 'setup' function from the Vue Composition API -->
<script>
import { ref } from 'vue';
import api, { setAuthToken } from "../apiConfig";
import { authMixin1 } from "../user_pages/userStore";
import { authMixin } from "../admin_pages/adminStore";
import Cookies from "js-cookie";
export default {
  name: "ChatBox",
  components: {},
  mixins: [authMixin],
  props: {
    TaskID: {
      type: String,
      required: true,
    },
    AssignedBy: {
      type: String,
      required: true,
    },
  },
  created() {
    // this.checkAuthorization();    
    this.getChatByTaskId(this.TaskID)
  },

  data() {
    return {
      tasks: [],
      //soket
      socket: null,
      message: '',
      receivedMessages: [],
      //socket
      UserID: '',
      searchText: '',
      filteredTasks: [],
      loadingTasks: "",
      taskFormHeader: "",
      successAlertOnSubmit: "",
      StatusCompleted: false,
      IsTasks: false,
      newchat: {
        TaskID: 0,
        DueDate: null,
        Message: "",
        Sender: "",
        SenderId: 0,
        Reciever: "",
        RecieverId: 0
      },
      taskValidate: {
        Message: "",
        // Add additional validation fields as needed
      },
      filtertask: [],
      isInputDisabled: true,
    };
  },
  mounted() {
    // let userCookie = Cookies.get("user");
    // userCookie = userCookie ? JSON.parse(userCookie) : null;
    // this.UserID = userCookie.UserID;
  },
  setup(props) {
    const TaskID = props.TaskID;
    const AssignedBy = props.AssignedBy;
    console.log("this is my task id"+TaskID);
    // Declare reactive variables using the 'ref' function
    const username = ref(null)
    const connect = ref(false)
    const text = ref(null)
    const messages = ref([])
    // The use of the WebSocket API 
    
    // const socket = new WebSocket('ws://localhost:4000')
    const socket = new WebSocket('ws://trackerapi.workanthem.com')
    const handleConnect = (username) => {
      if (username.value.length > 0) {
        connect.value = true
      }
    }
    const sendMessage = () => {
      // console.log(this.TaskID)
      let userCookie = Cookies.get("user");
      userCookie = userCookie ? JSON.parse(userCookie) : null;
      // this.UserID = userCookie.UserID;
      const messageData =  {
          Message: text.value,
          TaskID: parseInt(TaskID),
          Sender: userCookie.UserType,
          SenderName: userCookie.Username,
          SenderId: userCookie.UserID,
          Reciever: "Admin",
          RecieverId: parseInt(AssignedBy)
        };
      // Send the message data to the server using WebSockets
      socket.send(JSON.stringify(messageData))
      // Add the message data to the messages array
      messages.value.push(messageData)
      // this.newchat.push(messageData);
      // Clear the text input
      text.value = null;
    }

    // Define a WebSocket 'onmessage' event handler to receive messages from the server
    socket.onmessage = (event) => {
      const message = JSON.parse(event.data);
      messages.value.push(message);
    }

    // Return the reactive variables and event handlers to be used in the template
    return {
      text,
      connect,
      username,
      messages,
      handleConnect,
      sendMessage
    }
  },
  methods: {
    async getChatByTaskId(taskId) {
      try {
        this.loadingTasks = "Loading...";
        let userCookie = Cookies.get("user");
        userCookie = userCookie ? JSON.parse(userCookie) : null;
        this.UserID = userCookie.UserID;
        console.log("This is the cookie values: " + this.UserID);
        const token = Cookies.get("jwt");
        setAuthToken(token);
        const response = await api.get(`/api/Chat/get-chat-by-task-id/${taskId}`);
        if (response.data) {
          this.messages = response.data;
          console.log(this.newchat);
          this.loadingTasks = "";
        }
        else {
          // alert(`Error: ${response.statusText}`);
        }
      } catch (error) {
        //console.log(error);
        // if (error.response.status == 401) {
        //   const jsonResponseString = JSON.stringify(
        //     error.response.data.message
        //   );
        //   alert(jsonResponseString);
        //   this.$router.push("/");
        // }
        alert("Internal server error." + error);
      }
    },
  },
}
</script>


<style scoped>
/* Add Tailwind CSS classes here if needed */
.close-icon {
  cursor: pointer;
  float: right;
  font-size: 30px;
  margin-top: -10px;
}

.mb-3 {
  text-align: left;
}

.table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1em;
}

.table th,
.table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.table th {
  background-color: #f2f2f2;
}

/* Additional styling for left and right padding */
.table th,
.table td {
  padding-left: 12px;
  padding-right: 12px;
}

.actionBtns {
  text-align: right !important;
}

@media screen and (min-width:1020px) {
  #taskEditStatusModal .modal-dialog {
    width: 35%;
  }
}

.user-list {
  max-height: 120px;
  /* Set a maximum height for the user list */
  overflow-y: auto;
  /* Add a scrollbar when the content exceeds the height */
  border: 1px solid #ccc;
  /* Optional: Add a border for styling */
}

.user-item {
  margin-bottom: 8px;
  /* Optional: Add some spacing between user items */
}

.expired-row {
  background-color: #dc8484;
}

.badge-primary {
  color: #4ba64f !important;
  font-size: 14px !important;
}

.table-cell {
  font-size: 1.0625rem;
  padding-bottom: 10px;
  font-weight: 500;
}

.rowtaskNotAssigned {
  background: #faead6;
}

.rowtaskAssigned {
  background: #eaea8d;
}

.rowtaskInProcess {
  background: #b4e9d4;
}

.rowtaskCompleted {
  background: #9ed79e;
}

.dropdown {
  width: 100%;
  height: 36px;
  padding: 7px 0;
  font-size: 14px;
  line-height: 1.428571429;
  border-color: #D2D2D2;
}

.progress {
  float: left;
}

.highlight-text {
  margin-left: 5px;
  margin-right: 8px;
}

.highlight-text:hover {
  color: blue;
  font-weight: 400;
}

.color-box {
  display: inline-block;
  padding-left: 6px;
  cursor: pointer;
  padding-top: 5px;
}


/* chat box style */
.chat-box {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  overflow: auto;
  min-height: 350px;
  box-sizing: border-box;
  /* Ensure padding and border are included in the width */
}

.messages {
  min-height: 285px;
  overflow-y: auto;
  /* Add scrollbar if messages overflow */
}

.message {
  padding: 6px;
}


.received {
  font-weight: bold;
  align-items: flex-start;
  color: #ffffff;
  /* Change color according to your design */
  text-align: left;
  background-color: #6b7076;
  /* Change background color according to your design */
  border-radius: 10px;
  padding: 7px;
  max-width: 70%;
  /* Limit message width for better readability */
}

.sent {
  font-weight: bold;
  align-items: flex-end;
  text-align: right;
  color: #fff;
  /* Change color according to your design */
  background-color: #0084ff;
  /* Change background color according to your design */
  border-radius: 10px;
  padding: 7px;
  max-width: 70%;
  /* Limit message width for better readability */
}

.input-box {
  display: flex;
  justify-content: space-between;
  align-items: bottom;
  position: absolute;
  width: 94%;
  bottom: 30px;
  margin-top: 10px;
  /* Add margin between messages and input box */
}

.input-box input {
  flex: 1;
  margin-right: 5px;
}

.input-box button {
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
}

/* chat box style */
.modal-content .modal-header {
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.modal-title {
  margin-top: 10px;
}

.modal-content .modal-body {
  padding-top: 10px;
}

.task-table {
  width: 100%;
}

@media screen and (min-width:990px) and (max-width: 1185px) {
  .task-table {
    width: 1100px;
    overflow-x: auto
  }
}

@media screen and (max-width: 890px) {
  .task-table {
    width: 830px;
    overflow-x: auto
  }
}
</style>
